import { TLEditorSnapshot } from '@tldraw/tldraw';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface SaveChronologyVisualisationParams {
  matterId: string;
  subsetId: string;
  chronologyId: string;
  snapshot: TLEditorSnapshot;
}

export const useSaveChronologyVisualisation = () => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ matterId, subsetId, chronologyId, snapshot }: SaveChronologyVisualisationParams) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.POST,
        data: {
          snapshot,
        },
      });

      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/chronology/${chronologyId}/save-visualisation`,
        fetchConfig,
      );

      if (!response.ok) {
        throw new Error('Failed to save chronology visualisation');
      }

      return { subsetId, chronologyId };
    },
    {
      onSuccess: ({ subsetId, chronologyId }) => {
        // Invalidate the visualisation query to force refetch
        queryClient.invalidateQueries([QueryEntity.ChronologyVisualisation, { subsetId, chronologyId }]);
        toast.success('Visualisation saved');
      },
      onError: (error: Error) => {
        console.error('Error saving chronology visualisation:', error);
        toast.error('Failed to save visualisation');
      },
    },
  );
};
